package com.sddamico.swigmore.ds.poll

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeCaps
import com.sddamico.swigmore.ds.typeDisplay
import com.sddamico.swigmore.util.ordinal
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/**
 * "Votes by ballot position": one tile per position. The most common position is gold, other
 * non-zero positions green, zeros a faint tint. [counts] is indexed by ballot position (0 = 1st).
 */
@Composable
fun VoteDistribution(counts: List<Int>, modifier: Modifier = Modifier) {
  val max = counts.maxOrNull() ?: 0
  Div(
    attrs = Modifier
      .css("display" to "grid", "grid-template-columns" to "repeat(${counts.size.coerceAtLeast(1)},minmax(0,1fr))", "gap" to "5px")
      .then(modifier)
      .toAttrs()
  ) {
    counts.forEachIndexed { i, n ->
      val hot = n == max && n > 0
      val position = ordinal(i + 1).uppercase()
      val (bg, fg, lc) = when {
        hot -> Triple(SwColor.gold, SwColor.field700, SwColor.field700)
        n > 0 -> Triple(SwColor.field700, SwColor.cream, SwColor.gold)
        else -> Triple(SwColor.tintOnCream, SwColor.inkFaint, SwColor.inkFaint)
      }
      Div(
        attrs = Modifier.css("background" to bg, "color" to fg, "border-radius" to "5px",
          "text-align" to "center", "padding" to "7px 0 5px").toAttrs { attr("title", "$n at $position") }
      ) {
        Div(attrs = Modifier.typeDisplay("18px").toAttrs()) { Text(n.toString()) }
        Div(attrs = Modifier.typeCaps("8px", ".08em").css("margin-top" to "4px", "color" to lc).toAttrs()) {
          Text(position)
        }
      }
    }
  }
}
